import { createRouter, createWebHistory } from 'vue-router'
import PageAcessoRapido from 'pages/PageAcessoRapido.vue'
import PageArquivos from 'pages/PageArquivos.vue'
import PageDashboardCopa from 'pages/PageDashboardCopa.vue'
import PageManutencao from 'pages/PageManutencao.vue'
import PageSolicitacoes from 'pages/PageSolicitacoes.vue'
import PageTemplateUnificado from 'pages/PageTemplateUnificado.vue'

const routes = [
  {
    path: '/',
    name: 'acessoRapido',
    component: PageAcessoRapido,
  },
  {
    path: '/solicitacoes',
    name: 'solicitacoes',
    component: PageSolicitacoes,
  },
  {
    path: '/repositorios',
    name: 'repositorios',
    component: PageArquivos,
  },
  {
    path: '/template-unificado',
    name: 'templateUnificado',
    component: PageTemplateUnificado,
  },

  {
    path: '/dashboard-copa',
    name: 'dashboardCopa',
    component: PageDashboardCopa,
  },

  {
    path: '/manutencao',
    name: 'manutencao',
    component: PageManutencao,
  },
]

const router = createRouter({
  history: createWebHistory(),

  routes,
})

export default router
